// extracted by mini-css-extract-plugin
module.exports = {"blockWipe":"ScrollReveal-module--blockWipe--Oh306","isInView":"ScrollReveal-module--isInView--ApEtA","slideUp":"ScrollReveal-module--slideUp--b0r8L"};